<template>
    <van-popup
        :value="visible"
        position="bottom"
        class="task-list-popup"
        @close="close"
        @click-overlay="close"
    >
        <div class="popup-content">
            <img src="../../../../assets/img/task-popup-bg.png" class="top-bg" />
            <div class="icon-close" @click="close" />

            <div class="scroll-view-wrapper">
                <div class="scroll-view">
                    <template v-if="routePath === '/'">
                        <!-- 限时悬赏任务 -->
                        <limited-time-task-list
                            v-if="limitedTimeTaskListVisible"
                            :rewardTaskInfo="rewardTaskInfo"
                            @button-click="handleLimitedTimeTask"
                        ></limited-time-task-list>
                        <!-- 签到任务 -->
                        <signView
                            v-if="signInTaskInfo"
                            ref="signViewRef"
                            :signData="signInTaskInfo"
                            :switch3DCat="switch3d"
                            @signTaskSuccess="signtakeSuccCallBack"
                        />
                        <!-- 推荐任务 -->
                        <task-list
                            v-if="recommendTaskVisible"
                            :taskInfo="recommendTaskInfo"
                            class="mt-30 pb-25 border-bottom"
                            @button-click="handleRecommendTask"
                        ></task-list>
                        <!-- 每日任务 -->
                        <task-list
                            v-if="dailyTaskListVisible"
                            :taskInfo="dailyTaskInfo"
                            class="pb-25 border-bottom"
                            :class="{ 'mt-30': limitedTimeTaskListVisible }"
                            @button-click="handleDailyTask"
                        ></task-list>
                        <!-- 更多任务 -->
                        <task-list
                            v-if="moreTaskListVisible"
                            :taskInfo="moreTaskInfo"
                            class="mt-30"
                            @button-click="handleMoreTask"
                        ></task-list>
                    </template>
                    <template v-else>
                        <!-- 限时悬赏任务 -->
                        <limited-time-task-list
                            v-if="limitedTimeTaskListVisible"
                            :rewardTaskInfo="rewardTaskInfo"
                            @button-click="handleLimitedTimeTask"
                        ></limited-time-task-list>
                        <!-- 推荐任务 -->
                        <task-list
                            v-if="recommendTaskVisible"
                            :taskInfo="recommendTaskInfo"
                            class="mt-30 pb-25 border-bottom"
                            @button-click="handleRecommendTask"
                        ></task-list>
                        <!-- 更多任务 -->
                        <task-list
                            v-if="moreTaskListVisible"
                            :taskInfo="moreTaskInfo"
                            class="mt-30"
                            @button-click="handleMoreTask"
                        ></task-list>
                        <!-- 每日任务 -->
                        <task-list
                            v-if="dailyTaskListVisible"
                            :taskInfo="dailyTaskInfo"
                            class="pb-25 border-bottom"
                            :class="{ 'mt-30': limitedTimeTaskListVisible }"
                            style="margin-top: 30px"
                            @button-click="handleDailyTask"
                        ></task-list>
                        <!-- 签到任务 -->
                        <signView
                            v-if="signInTaskInfo"
                            ref="signViewRef"
                            :signData="signInTaskInfo"
                            :switch3DCat="switch3d"
                            @signTaskSuccess="signtakeSuccCallBack"
                        />
                    </template>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { mapState } from 'vuex';
import LimitedTimeTaskList from './LimitedTimeTaskList';
import TaskList from './TaskList';
import signView from './../signView/popsign.vue';
import InteractiveController from '../../../../common/animations3D/controller';
export default {
    name: 'TaskListPopup',
    components: {
        LimitedTimeTaskList,
        TaskList,
        signView
    },
    props: {
        visible: {
            type: Boolean
        },
        taskListInfo: {
            type: Object
        },
        scoreInfoData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            signInTaskInfo: null,
            switch3d: true,
            routePath: this.$route.path
        };
    },
    computed: {
        ...mapState({
            isOldCustomer: state => state.home.isOldCustomer
        }),
        dailyTaskInfo() {
            return this.taskListInfo.popupDailyTask || {};
        },
        recommendTaskInfo() {
            return this.taskListInfo.recommendTask || {};
        },
        rewardTaskInfo() {
            return this.taskListInfo.popupRewardTask || {};
        },
        moreTaskInfo() {
            return this.taskListInfo.popupMoreTask || {};
        },
        limitedTimeTaskListVisible() {
            return (
                Object.keys(this.rewardTaskInfo).length > 0 &&
                this.rewardTaskInfo.taskList.length > 0
            );
        },
        dailyTaskListVisible() {
            return (
                Object.keys(this.dailyTaskInfo).length > 0 && this.dailyTaskInfo.taskList.length > 0
            );
        },
        recommendTaskVisible() {
            return (
                Object.keys(this.rewardTaskInfo).length > 0 &&
                this.recommendTaskInfo.taskList.length > 0
            );
        },
        moreTaskListVisible() {
            return (
                Object.keys(this.moreTaskInfo).length > 0 && this.moreTaskInfo.taskList.length > 0
            );
        },
        page() {
            const fullPath = this.$route.fullPath;
            if (fullPath.indexOf('/benefitExchange?type=0') > -1) {
                return '等级权益-免息券详情页';
            }
            if (fullPath.indexOf('/benefitExchange?type=14') > -1) {
                return '等级权益-话费券详情页';
            }
            if (fullPath.indexOf('/benefitExchange?type=6') > -1) {
                return '等级权益-息费折扣券页';
            }
            if (fullPath.indexOf('/benefitExchange?type=1') > -1) {
                return '等级权益-还款券详情页';
            }
            const path = this.$route.path;
            const map = {
                '/allBenefit': '全部权益页',
                '/': '成长权益页',
                '/seckill': '权益日活动'
            };
            return map[path];
        },
        eventId() {
            const fullPath = this.$route.fullPath;
            if (
                fullPath.indexOf('/benefitExchange?type=0') > -1 ||
                fullPath.indexOf('/benefitExchange?type=1') > -1 ||
                fullPath.indexOf('/benefitExchange?type=14') > -1 ||
                fullPath.indexOf('/benefitExchange?type=6') > -1
            ) {
                return 'privilege';
            }
            const path = this.$route.path;
            const map = {
                '/allBenefit': 'allPrivilege',
                '/': 'privilege',
                '/seckill': 'privilege'
            };
            return map[path];
        },
        tgtName() {
            const fullPath = this.$route.fullPath;
            if (
                fullPath.indexOf('/benefitExchange?type=0') > -1 ||
                fullPath.indexOf('/benefitExchange?type=1') > -1 ||
                fullPath.indexOf('/benefitExchange?type=14') > -1 ||
                fullPath.indexOf('/benefitExchange?type=6') > -1
            ) {
                return '成长权益-任务浮窗';
            }
            const path = this.$route.path;
            const map = {
                '/allBenefit': '全部权益页-任务浮窗',
                '/': '成长权益-任务浮窗',
                '/seckill': '成长权益-任务浮窗'
            };
            return map[path];
        }
    },
    watch: {
        visible: {
            handler: 'exposureTaskList',
            immediate: false
        }
    },
    methods: {
        // 用户签到任务信息
        async getSignInTaskInfo() {
            const { Result, Content } = await this.$http.getSignInTaskInfo({});
            if (Result === 200 && Content) {
                if (Content.signInTask && Content.signInTask.taskEndInDays > 0) {
                    this.signInTaskInfo = Content.signInTask;
                    this.signTaskPoint('h5_element_imp');
                }
                this.switch3d = InteractiveController.cat3dGrayscale(Content.enabled3d);
            }
        },
        // 触发签到--必须任务信息数据已获取
        async callSignInAfterDataReady() {
            await this.getSignInTaskInfo();
            let { currentDay, taskStatusInfoList } = this.signInTaskInfo;
            let item = taskStatusInfoList.find(ele => ele.day === currentDay);
            this.$nextTick(() => {
                // 等签到任务信息数据返回再执行签到操作，签到成功刷新列表
                item &&
                    this.$refs.signViewRef.takeSignInTask(item, () =>
                        this.$emit('refreshTaskList')
                    );
            });
        },
        close() {
            console.log('popup-close11');
            // this.$emit('update:visible', false);
            this.$emit('OnCloseTaskListPop');
        },
        signtakeSuccCallBack() {
            // 签到任务领取成功
            this.signTaskPoint('h5_clk');
            this.getSignInTaskInfo();
            if (this.routePath === '/') {
                this.$emit('OnSigntakeSuccCallBack');
            }
        },
        handleLimitedTimeTask(task, index) {
            this.handleTaskClick(task, 'handleLimitedTimeTask', index);
        },
        handleRecommendTask(task) {
            this.handleTaskClick(task, 'recommendTask');
        },
        handleDailyTask(task) {
            this.handleTaskClick(task, 'handleDailyTask');
        },
        handleMoreTask(task) {
            this.handleTaskClick(task, 'handleMoreTask');
        },
        // 点击浮窗内任务时的埋点统计及相关逻辑
        handleTaskClick(item, moduleId, index) {
            let countDV =
                moduleId === 'popupRewardTask'
                    ? document.getElementById('count-down-value' + index).innerText
                    : '';
            this.POINT('h5_clk', {
                page: `super-${this.page}`,
                tgt_event_id: `h5_ACT_${this.eventId}_taskbox`,
                tgt_name: `h5-ACT-${this.tgtName}`,
                param: this.scoreInfoData.totalScore,
                param1: `${item.title}`,
                param2: moduleId,
                param3: item.afterRewardScore ? item.afterRewardScore : '',
                param4: item.taskButtonText,
                param5: item.desc ? item.desc : '',
                param6: item.score,
                param7: item.afterRewardScore ? item.afterRewardScore - item.score : '',
                param8: countDV ? countDV : '',
                param9: item.taskId,
                param10: this.scoreInfoData.allScore,
                param11: this.switch3d ? '是' : '否'
            });
            if (item.taskHandler === 'ReceiveScoreTaskHandler') {
                this.$emit('OnReceiveScoreTask');
                this.$emit('OnCloseTaskListPop');
                return;
            }
            if (!item.redirectUrl && item.redirectUrl.length === 0) {
                return;
            }
            if (item.taskId > 804 && item.taskId < 812) {
                // 房贷申请:805 房贷成交:806 车贷申请: 807  车贷签约:808  车贷成交: 809 试算线索:811
                this.taskReceive(item);
                return;
            }
            if (item.taskStatus === 1 || item.taskStatus === 3) {
                // 状态认证中,已完成，无跳转连接均不响应
                if ([101, 204, 618, 619].indexOf(item.taskId) > -1) {
                    // 借款任务：101，视频浏览任务：204，团险浏览任务：618，浏览法人报告：619， 认证中或已完成可以继续浏览
                    this.$emit('OnCloseTaskListPop');
                    this.$emit('OnOpenLinkClick', item.redirectUrl);
                }
                return;
            }
            if (item.taskId === 310) {
                // 通知权限设置
                this.$emit('OnClickNoticeType', item.redirectUrl);
                return;
            }
            if (item.taskId === 311) {
                // 权益日活动
                this.$emit('OnCloseTaskListPop');
                this.$emit(
                    'OnOpenLinkClick',
                    `${window.location.protocol}//invgrowth.ppdai.com/#${item.redirectUrl}`
                );
                return;
            }
            if (
                item.taskHandler === 'LLHDongTaskHandler' ||
                item.taskHandler === 'JBSLLHDongTaskHandler'
            ) {
                this.$emit('OnMarketTipClick', item);
                this.$emit('OnCloseTaskListPop');
                return;
            }
            if (item.taskId === 309) {
                // 微信公众号
                this.$copyText('上海拍拍贷').then(
                    function(e) {
                        this.$toast({
                            message: '已为您复制"上海拍拍贷"公众号，正在跳转微信',
                            duration: 2000
                        });
                    },
                    function(e) {
                        console.log(e);
                    }
                );
            }
            this.$emit('OnCloseTaskListPop');
            this.$emit('OnOpenLinkClick', item.redirectUrl);
        },
        async taskReceive(item) {
            if (item.taskStatus === 0) {
                const { Result } = await this.$http.taskReceive({
                    taskId: item.taskId
                });
                if (Result === 200) {
                    if (item.redirectUrl) {
                        this.$emit('OnCloseTaskListPop');
                        this.$emit('OnOpenLinkClick', item.redirectUrl);
                    }
                }
            } else {
                if (item.redirectUrl) {
                    if (item.taskStatus === 3 && item.taskId === 811) {
                        return;
                    }
                    this.$emit('OnCloseTaskListPop');
                    this.$emit('OnOpenLinkClick', item.redirectUrl);
                }
            }
        },
        signTaskPoint(type) {
            let signScore = '';
            let signStatus = '';
            this.signInTaskInfo.taskStatusInfoList.forEach(item => {
                signScore = signScore.concat(item.score + ',');
                if (this.signInTaskInfo.currentDay === item.day) {
                    signStatus = item.status === 0 ? '未签到' : '已签到';
                }
            });
            this.POINT(type, {
                page: `super-${this.page}`,
                tgt_event_id: `h5_ACT_${this.eventId}_taskbox`,
                tgt_name: `h5-ACT-${this.tgtName}`,
                param: this.scoreInfoData.totalScore,
                param1: '签到任务',
                param10: this.scoreInfoData.allScore,
                param11: this.switch3d ? '是' : '否',
                param14: this.signInTaskInfo.currentDay,
                param15: signScore,
                param16: this.signInTaskInfo.taskEndInDays,
                param17: type === 'h5_clk' ? '' : signStatus
            });
        },
        // 极速升级 && 每日互动曝光埋点
        fastUpdataTaskPoint(taskData) {
            if (taskData && taskData.taskList) {
                let moduleId = taskData.moduleId;
                if (moduleId === 'popupRewardTask') {
                    setTimeout(() => {
                        taskData.taskList.forEach((item, itemIndex) => {
                            let countDV = document.getElementById('count-down-value' + itemIndex)
                                .innerText;
                            this.POINT('h5_element_imp', {
                                page: `super-${this.page}`,
                                tgt_event_id: `h5_ACT_${this.eventId}_taskbox`,
                                tgt_name: `h5-ACT-${this.tgtName}`,
                                param: this.scoreInfoData.totalScore,
                                param1: `${item.title}`,
                                param2: moduleId,
                                param3: item.afterRewardScore ? item.afterRewardScore : '',
                                param4: item.taskButtonText,
                                param5: item.desc ? item.desc : '',
                                param6: item.score,
                                param7: item.afterRewardScore
                                    ? item.afterRewardScore - item.score
                                    : '',
                                param8: countDV ? countDV : '',
                                param9: item.taskId,
                                param10: this.scoreInfoData.allScore,
                                param11: this.switch3d ? '是' : '否'
                            });
                        });
                    }, 1200);
                } else {
                    taskData.taskList.forEach(item => {
                        this.POINT('h5_element_imp', {
                            page: `super-${this.page}`,
                            tgt_event_id: `h5_ACT_${this.eventId}_taskbox`,
                            tgt_name: `h5-ACT-${this.tgtName}`,
                            param: this.scoreInfoData.totalScore,
                            param1: `${item.title}`,
                            param2: moduleId,
                            param3: item.afterRewardScore ? item.afterRewardScore : '',
                            param4: item.taskButtonText,
                            param5: item.desc ? item.desc : '',
                            param6: item.score,
                            param7: item.afterRewardScore ? item.afterRewardScore - item.score : '',
                            param8: '',
                            param9: item.taskId,
                            param10: this.scoreInfoData.allScore,
                            param11: this.switch3d ? '是' : '否'
                        });
                    });
                }
            }
        },
        exposureTaskList(newVal) {
            if (newVal !== true) {
                return;
            }
            this.getSignInTaskInfo();
            if (this.taskListInfo) {
                const {
                    popupRewardTask,
                    popupDailyTask,
                    popupMoreTask,
                    recommendTask
                } = this.taskListInfo;
                popupRewardTask && this.fastUpdataTaskPoint(popupRewardTask);
                popupDailyTask && this.fastUpdataTaskPoint(popupDailyTask);
                popupMoreTask && this.fastUpdataTaskPoint(popupMoreTask);
                recommendTask && this.fastUpdataTaskPoint(recommendTask);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.task-list-popup {
    height: 70%;
    background-color: transparent;
    overflow-y: visible;
    .popup-content {
        position: relative;
        height: 100%;
        background: #fff;
        .top-bg {
            position: absolute;
            top: -106px;
            width: 100%;
        }
        .icon-close {
            position: absolute;
            width: 30px;
            height: 54px;
            top: -75px;
            right: 20px;
            background-image: url('../../../../assets/img/task-popup-close.png');
            background-size: 100% 100%;
        }
        .scroll-view-wrapper {
            padding-top: 20px;
            height: 100%;
            background: #fff;
            .scroll-view {
                position: relative;
                z-index: 1;
                height: 100%;
                padding: 0 18px 60px 20px;
                overflow-y: scroll;
            }
        }
    }
}
.mt-30 {
    margin-top: 30px;
}
.pb-25 {
    padding-top: 2px;
    padding-bottom: 25px;
}
.border-bottom {
    border-bottom: 1px solid #f5f8fa;
}
</style>
